module.exports = __webpack_public_path__ + "img/img2-3.ff83238f.png";